import { useEffect } from "react";
import { useBranch } from "@/contexts/BranchContext";
import { applyFonts } from "@/lib/landingFonts";

/**
 * Watches the currently-selected school and applies its `font_heading`,
 * `font_body`, `font_button` to the document via CSS variables. Mounted near
 * the top of the dashboard tree so every owner / staff page automatically
 * inherits the school's typography choices.
 *
 * Renders nothing.
 */
export default function FontApplier() {
  const { selectedSchool } = useBranch();
  useEffect(() => {
    applyFonts({
      heading: selectedSchool?.font_heading || null,
      body: selectedSchool?.font_body || null,
      button: selectedSchool?.font_button || null,
    });
  }, [selectedSchool?.font_heading, selectedSchool?.font_body, selectedSchool?.font_button]);
  return null;
}
